import type { SessionNoteSettings, SessionNoteType } from '@/entities/session-note';

import type { EditableNoteSettingKey } from '../model/edit-session-note-settings.types';

type SettingDef<K extends EditableNoteSettingKey> = {
    key: K;
    label: string;
    size?: 'sm';
    options: { value: SessionNoteSettings[K]; label: string }[];
};

type SettingDefs = {
    [K in EditableNoteSettingKey]: SettingDef<K>;
};

export const SETTING_DEFS: SettingDefs = {
    format: {
        key: 'format',
        label: 'Format',
        size: 'sm',
        options: [
            { value: 'narrative', label: 'Narrative' },
            { value: 'bulleted', label: 'Bulleted' },
        ],
    },
    length: {
        key: 'length',
        label: 'Length',
        size: 'sm',
        options: [
            { value: 'concise', label: 'Concise' },
            { value: 'standard', label: 'Standard' },
        ],
    },
    identifier: {
        key: 'identifier',
        label: 'Identifier',
        options: [
            { value: 'client', label: 'Client' },
            { value: 'patient', label: 'Patient' },
        ],
    },
};

export const SETTINGS_BY_NOTE_TYPE: Record<SessionNoteType, EditableNoteSettingKey[]> = {
    SOAP: ['format', 'length', 'identifier'],
    NESSO: ['length', 'identifier'],
};
